import React from 'react';

import { config } from '../../config';
import { useAppSelector } from '../../hooks';
import { selectIsStaff } from '../../selectors/selectAppDetails';

export const WelcomeBadge = () => {
  const isStaff = useAppSelector(selectIsStaff);
  const imgUrl = config.endpoints.feefo.badgeUrl;
  if (isStaff) {
    return null;
  }

  return (
    <img
      alt="Our customer Feefo rating"
      src={imgUrl}
      title="Our customer Feefo rating"
      data-track="feefoLogo"
    />
  );
};
